module.exports = __webpack_public_path__ + "static/media/brand-logo.3053607d.svg";